import {
  LF_TOGGLE_SHOW_LINES,
  LF_TOGGLE_SHOW_BACKGROUND,
  LF_TOGGLE_SHOW_CONTROLS,
  LF_TOGGLE_DRAW_IN_PROGRESS,
  LF_TOGGLE_DRAW_FINISHED,
  LF_SET_NEXT_PATH_INDEX,
  LF_RESET_PATH_INDEX,
  LF_ENABLE_CONTINUOUS_DRAW,
  LF_CLEAR_ALL_PATHS,
  LF_AUDIO_DOWNLOAD_REQUEST,
  LF_AUDIO_DOWNLOAD_RESPONSE,
  LF_SHOW_START_BUTTON,
  LF_SET_AUDIO,
} from '../action-types/draw-stage';

export function toggleShowLines() {
  return {
    type: LF_TOGGLE_SHOW_LINES
  };
}

export function toggleShowBackground() {
  return {
    type: LF_TOGGLE_SHOW_BACKGROUND
  };
}

export function toggleShowControls(show) {
  return {
    type: LF_TOGGLE_SHOW_CONTROLS,
    show
  };
}

export function toggleDrawInProgress(inProgress) {
  return {
    type: LF_TOGGLE_DRAW_IN_PROGRESS,
    inProgress
  };
}

export function setNextPathIndex() {
  return {
    type: LF_SET_NEXT_PATH_INDEX
  };
}

export function resetPathIndex() {
  return {
    type: LF_RESET_PATH_INDEX
  };
}

export function toggleDrawFinished(finished) {
  return {
    type: LF_TOGGLE_DRAW_FINISHED,
    finished
  };
}

export function enableContinuousDraw() {
  return {
    type: LF_ENABLE_CONTINUOUS_DRAW
  };
}

export function clearAllPaths() {
  return {
    type: LF_CLEAR_ALL_PATHS
  };
}

export function audioDownloadRequest() {
  return {
    type: LF_AUDIO_DOWNLOAD_REQUEST
  };
}

export function audioDownloadResponse() {
  return {
    type: LF_AUDIO_DOWNLOAD_RESPONSE
  };
}

export function displayStartButton(show) {
  return {
    type: LF_SHOW_START_BUTTON,
    show
  };
}

export function setAudio(playing) {
  return {
    type: LF_SET_AUDIO,
    playing
  };
}